var map = {
	"./default/logo_notifications.png": [
		5409,
		5409
	],
	"./documentation/logo_notifications.png": [
		27026,
		27026
	],
	"./epista/logo_notifications.png": [
		23541,
		23541
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 69495;
module.exports = webpackAsyncContext;